import {NgModule} from '@angular/core';
import {ShareModule} from '@share/share.module';
import {WorkflowModule} from '../workflow/workflow.module';
import {OpeCarteListComponent} from './opecarte-list/opecarte-list.component';
import {OpeCarteListItemComponent} from './opecarte-list/opecarte-list-item/opecarte-list-item.component';
import {OpeCarteService} from './opecarte.service';
import {EffectsModule} from "@ngrx/effects";
import {OpecarteEffects} from "@components/opecarte/opecarte.effects";
import {EtatOperationComponent} from "@components/opecarte/etat-operation.component";

@NgModule({
    imports: [ShareModule, WorkflowModule, EffectsModule.forFeature([OpecarteEffects])],
    declarations: [OpeCarteListComponent, OpeCarteListItemComponent, EtatOperationComponent],
    providers: [OpeCarteService],
    exports: [OpeCarteListComponent]
})
export class OpeCarteModule {}
